module.exports = __webpack_public_path__ + "img/pr-2.a968bba8.png";